import React, { useEffect, useState } from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import ExerciseTypeForm from '../../../components/forms/ExerciseTypeForm';
import { useExerciseTypeApi } from '../../../hooks/useExerciseTypeApi';
import { useNavigate, useParams } from 'react-router-dom';
import Card from '../../../components/common/Card';
import { ExerciseTypeDTO } from '../../../services/apiClient';

const ExerciseTypeEdit: React.FC = () => {
  const { getById, edit, isLoading } = useExerciseTypeApi();
  const [entityData, setEntityData] = useState<ExerciseTypeDTO | null>(null);
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Exercise Types', href: '/admin/exercisetypes' },
    { label: 'Edit', href: '#' },
  ];

  useEffect(() => {
    const fetchEntityData = async () => {
      try {
        const response = await getById(id!);
        setEntityData(response?.data || null);
      } catch (error) {
        console.error('Error fetching Exercise Type data:', error);
      }
    };

    fetchEntityData();
  }, [id]);

  const handleSubmit = async (data: any) => {
    try {
      await edit(id!, data);
      navigate('/admin/exercisetypes');
    } catch (error) {
      console.error('Error updating Exercise Type:', error);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/exercisetypes"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission='Settings.ExerciseType.Edit'
    >
        {entityData ? (
          <ExerciseTypeForm
            initialValues={entityData}
            onSubmit={handleSubmit}
            onCancel={() => navigate('/admin/exercisetypes')}
          />
        ) : (
          <p>Loading...</p>
        )}
    </AdminLayout>
  );
};

export default ExerciseTypeEdit;